export const RETAIL_SALES_PROFILE_TYPE = 'Shopping & Retail' as const;

export const RETAIL_SALES_MONTHLY_PRODUCT_CODE = 'RETAIL_MONTHLY' as const;
export const RETAIL_SALES_ANNUAL_PRODUCT_CODE = 'RETAIL_ANNUAL' as const;
/** 30-day free trial — converts to RETAIL_MONTHLY on day 31 via PayFast billing_date. */
export const RETAIL_SALES_TRIAL_PRODUCT_CODE = 'RETAIL_TRIAL_30' as const;

// ── Early Adopters Lifetime Promo ──────────────────────────────────────────
// Existing subscribers (Shopaholic) keep these rates while active.
// Cancel/default → going rate.
// LEGACY (going) prices — DO NOT DELETE:
export const RETAIL_SALES_MONTHLY_PRICE_LEGACY = 975 as const;
export const RETAIL_SALES_ANNUAL_PRICE_LEGACY = 9500 as const;

// ── Current (going-rate) prices — effective now ──────────────────────────
export const RETAIL_SALES_MONTHLY_PRICE = 500 as const;
export const RETAIL_SALES_ANNUAL_PRICE = 5000 as const;

export const RETAIL_SALES_CATEGORY_OPTIONS = [
  'Baby & Kids',
  'Books & Stationery',
  'Clothing & Fashion',
  'Electronics & Gadgets',
  'Flowers & Gifts',
  'Furniture & Decor',
  'Groceries & Food',
  'Health & Beauty',
  'Home & Kitchen',
  'Jewelry & Accessories',
  'Office Supplies',
  'Outdoor & Garden',
  'Pet Supplies',
  'Sports & Fitness',
  'Tools & Hardware',
  'Toys & Hobbies',
] as const;

export const isRetailSalesProductCode = (value: unknown): boolean => {
  const code = String(value || '').trim();
  return (
    code === RETAIL_SALES_MONTHLY_PRODUCT_CODE ||
    code === RETAIL_SALES_ANNUAL_PRODUCT_CODE ||
    code === RETAIL_SALES_TRIAL_PRODUCT_CODE
  );
};